"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _formatters = require("../../utils/formatters");
var _types = require("../../utils/types");
require("./ChatItem.scss");
var _ImageIcon = _interopRequireDefault(require("../common/ImageIcon/ImageIcon"));
var _Stopwatch = _interopRequireDefault(require("../common/Stopwatch/Stopwatch"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ChatItem = function ChatItem(_ref) {
  var id = _ref.id,
    type = _ref.type,
    user = _ref.user,
    text = _ref.text,
    unread = _ref.unread,
    date = _ref.date,
    campaign = _ref.campaign,
    active = _ref.active,
    timeUnattended = _ref.timeUnattended,
    onClick = _ref.onClick,
    typeMedia = _ref.typeMedia,
    warning = _ref.warning,
    disabledStopwatch = _ref.disabledStopwatch,
    timeoutReached = _ref.timeoutReached;
  var _useTranslation = (0, _reactI18next.useTranslation)('commons'),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var lang = i18n.language.slice(0, 2);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: "uin-list-item uin-chat-item ".concat(active ? 'active' : '', " ").concat(timeoutReached ? 'timeoutReached' : '', " "),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-lic-bar"
  }), unread > 0 && !active && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-lic-dot"
  }), /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
    type: campaign.type,
    name: campaign.name,
    image: campaign.graphicId
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ci-body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ci-info"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "uin-ci-user c100"
  }, user), timeUnattended !== null && /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-lic-timeout ' + (warning ? 'warning' : '')
  }, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], {
    initialTime: timeUnattended,
    disabled: disabledStopwatch
  })), /*#__PURE__*/_react["default"].createElement("time", {
    className: "c600",
    dateTime: date
  }, (0, _formatters.formatTimeShort)(date, lang)), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-ci-unread' + (typeof unread === 'boolean' || unread <= 0 ? ' hidden' : '')
  }, (unread > 9 ? '+' : '') + Math.min(unread, 9)), /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + type.toLowerCase() + ' uin-lic-icon'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ci-preview c500"
  }, typeMedia !== 'text' && typeMedia !== 'template' ? typeMedia === 'unsupported' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon warning"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ci-text"
  }, t('whatsapp:unsupported'))) : typeMedia === 'image' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon image"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ci-text"
  }, t('whatsapp:image'))) : typeMedia === 'video' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon video-camera"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ci-text"
  }, t('whatsapp:video'))) : typeMedia === 'audio' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon headset"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ci-text"
  }, t('whatsapp:audio'))) : typeMedia === 'file' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon document"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ci-text"
  }, t('whatsapp:file'))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ci-text"
  }, typeMedia) : text ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-ci-text"
  }, text) : /*#__PURE__*/_react["default"].createElement("em", {
    className: "uin-lic-new-ph"
  }, t('new-convo')))));
};
ChatItem.propTypes = {
  id: _propTypes["default"].number,
  user: _propTypes["default"].string.isRequired,
  campaign: _types.campaignType.isRequired,
  text: _propTypes["default"].string,
  unread: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),
  date: _propTypes["default"].instanceOf(Date).isRequired,
  active: _propTypes["default"].bool,
  typing: _propTypes["default"].bool,
  timeUnattended: _propTypes["default"].instanceOf(Date),
  warning: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired,
  timeoutReached: _propTypes["default"].bool,
  disabledStopwatch: _propTypes["default"].bool
};
ChatItem.defaultProps = {
  unread: false,
  timeUnattended: null,
  disabledStopwatch: false,
  typeMedia: 'text'
};
var _default = exports["default"] = ChatItem;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ChatListItem/ChatItem.js
// module id = 1396
// module chunks = 0